const StateKey = 'evidues-state'

export class LocaleStorage {

	static loadState (): any {
		try {
			const serializedState = localStorage.getItem(StateKey)
			if (serializedState === null) {
				return undefined
			}
			return JSON.parse(serializedState)
		} catch (err) {
			console.error(err)
			return undefined
		}
	}

	static saveState (state: any): void {
		let serializedState = undefined
		try {
			serializedState = JSON.stringify(state)
			localStorage.setItem(StateKey, serializedState)
		} catch (e) {
			console.log(state)
			console.error(e)
		}
	}

}
